import React, { memo } from 'react';
import { Helmet } from 'react-helmet';

interface SupportWidgetProps {
  enabled: boolean;
}

export const SupportWidget: React.FC<React.PropsWithChildren<SupportWidgetProps>> = memo(({ enabled }) => {
  if (!enabled) {
    return null;
  }
  return (
    <Helmet>
      <script
        src="https://solve-widget.forethought.ai/embed.js"
        id="forethought-widget-embed-script"
        data-api-key="feee7aa9-2ab7-4382-9b0a-514b6bdf02b2"
        data-ft-embed-script-language="en"
      />
    </Helmet>
  );
});
